class ValidUtil {
    static isValidEmail(string) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailRegex.test(string);
    }

    static validatePassword(string) {
        const regex =
            /^(?!([a-zA-Z]+|\d+|[!@#$%^&*()_+=-[\]{}|\\:;"'<>,.?/`~]+)$)(?=.{8,})[a-zA-Z\d!@#$%^&*()_+=-[\]{}|\\:;"'<>,.?/`~]+$/;

        return regex.test(string);
    }
}

export default ValidUtil;
